class PandaConsole {
	public static $INIT():void {

		PandaConsole.onErrorUncritical = new Signal<(error:Error | PandaError)=>void>();
		PandaConsole.onLog = new Signal<(level:PandaConsoleMessageLevel, message:string, args: Array<any>)=>void>();

		GlobalErrorListener.onGlobalError.addListener(PandaConsole.handler_unhaltedError);
		this.onErrorUncritical.addListener(function PandaConsole_handler_errorUncritical (error:Error | PandaError):void { 
			PandaConsole.logWarn('' + error);
			let stack:string = PandaError.getStacktrace(error);
			if (stack) {
				PandaConsole.logWarn(stack);
			}
		});

		function colorConsoleWriter (level:PandaConsoleMessageLevel, message:string, args: Array<any>):void {
			let argsCopy = args.slice();
			if (PandaConsoleMessageStyles.hasStyle(level)) {
				argsCopy.unshift('%c ' + message, PandaConsoleMessageStyles.getStyle(level));
			} else {
				argsCopy.unshift(message);
			}
			console.log.apply(console, argsCopy);
		}
		
		function normalConsoleWriter (level:PandaConsoleMessageLevel, message:string, args: Array<any>):void {
			let argsCopy = args.slice();
			argsCopy.unshift(message);
			console.log.apply(console, argsCopy);
		}

		function stupidConsoleWriter (level:PandaConsoleMessageLevel, message:string, args: Array<any>):void {
			if (level === PandaConsoleMessageLevels.WARN) {
				//debugger;
			}
			let argsCopy = args.slice();
			argsCopy.unshift(message);
			console.log(level + ' ' + argsCopy.join(' '));
		}

 		 if (typeof console === "undefined" || typeof console.log === "undefined") {
 		 	// skip logging to console
 		} else {
			if (console.log) {
				if (console.log.apply) {
					if (this.colorsSupport()) {
						this.onLog.addListener(colorConsoleWriter);
					} else {
						this.onLog.addListener(normalConsoleWriter);
					}
				} else {
					this.onLog.addListener(stupidConsoleWriter);
				}
			}
		}

		if (BuildProperties.online === 'true') {
			this._sender = new FlogsSender();
			this.onLog.addListener(this._sender.handler_log);
		}
	}

	private static _sender:FlogsSender;

	public static logInfo(message:string, ...args: Array<any>):void {
		this.onLog.emit(PandaConsoleMessageLevels.INFO, message, args);
	}

	public static logDebug(message:string, ...args: Array<any>):void {
		this.onLog.emit(PandaConsoleMessageLevels.DEBUG, message, args);
	}

	public static logWarn(message:string, ...args: Array<any>):void {
		this.onLog.emit(PandaConsoleMessageLevels.WARN, message, args);
	}

	public static logError(message:string, ...args: Array<any>):void {
		this.onLog.emit(PandaConsoleMessageLevels.ERROR, message, args);
	}

	public static errorUncritical(error:Error | PandaError):void {
		this.onErrorUncritical.emit(error);
	}

	public static here:boolean = true;

	public static onErrorUncritical: Signal<(error:Error | PandaError)=>void> = null;
	public static onLog:Signal<(level:PandaConsoleMessageLevel, message:string, args: Array<any>)=>void> = null;

	private static handler_unhaltedError(msg:string, url:string, line:number, col:number, error:any):void {
		PandaConsole.logError(msg, url, line, col, PandaError.getStacktrace(error));
	}

	private static _colorsSupport:boolean = null;
	private static colorsSupport():boolean {
		if (this._colorsSupport == null) {
			this._colorsSupport = BrowserSpecific.colorsInConsole();
		}
		return this._colorsSupport;
	}
}